import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { BaseClass } from '../../../../shared/base-class';
import { takeUntil } from 'rxjs/operators';
import { ApplicantData } from '../../../../modules/submission-management/data/applicant.data';
import { GenericConstants } from '../../../../shared/constants/generic.constants';
import { AuthService } from '../../auth.service';
import * as moment from 'moment';
import { PropertyData } from 'app/modules/submission-management/data/property.data';
import { CoveragesData } from 'app/modules/submission-management/data/coverages.data';
import { SummaryData } from 'app/modules/submission-management/data/summary.data';

interface formType {
  ho3: string;
  ho4: string;
  ho6: string;
  dp3: string;
}

@Injectable({
  providedIn: 'root'
})
export class QuickQuoteValidationService extends BaseClass  {
  genericConstants = GenericConstants;
  effectiveDate: Date;
  userType: string;
  isEffectiveDateValid: boolean;
  public isQuickQuoteValid: boolean = false;

  public formType: formType = {
    ho3: 'HO3',
    ho4: 'HO4',
    ho6: 'HO6',
    dp3: 'DP3'
  };

  constructor(
    protected authService: AuthService,
    protected applicantData: ApplicantData,
    protected propertyData: PropertyData,
    protected coveragesData: CoveragesData,
    protected summaryData: SummaryData
  ) {
    super();
  }

  checkQuickQuotePage(): void {
    this.isQuickQuoteValid = this.isApplicantFormValid &&
      this.isPropertyFormValid &&
      this.isCoveragesFormValid;
  }

  isQuickQuoteEffectivaDateValid(): boolean {
    const currentDate = this.authService.getCustomDate();
    this.effectiveDate = this.applicantData.mainApplicant.get('effectiveDate').value.singleDate?.jsDate;
    const formattedEffectiveDate = new DatePipe('en-US').transform(this.effectiveDate, 'MM/dd/yyyy');
    const formattedcurrentDate = new DatePipe('en-US').transform(currentDate, 'MM/dd/yyyy');

    this.authService.userType.pipe(takeUntil(this.stop$)).subscribe(x => {
      this.userType = x;
    });

    if (moment(formattedEffectiveDate).isBefore(formattedcurrentDate) && this.userType === this.genericConstants.userType.external ) {
      this.isEffectiveDateValid = false;
      return false;
    } else {
        this.isEffectiveDateValid = true;
      return true;
    }
  }

  get isApplicantFormValid(): boolean {
    let isValid: boolean = false;

    isValid = this.applicantData.mainApplicant.get('firstName').valid &&
      this.applicantData.mainApplicant.get('lastName').valid &&
      this.applicantData.mainApplicant.get('effectiveDate').valid &&
      this.applicantData.mainApplicant.get('dateOfBirth').valid &&
      this.applicantData.mainApplicant.get('addressLine1').valid &&
      this.applicantData.mainApplicant.get('qqCity').valid &&
      this.applicantData.mainApplicant.get('qqState').valid &&
      this.applicantData.mainApplicant.get('qqZipCode').valid;

    return isValid;
  }

  get isPropertyFormValid(): boolean {
    let isValid: boolean = this.propertyData.propertyDetails.get('yearBuilt').valid &&
      this.propertyData.propertyDetails.get('exteriorWallFinish').valid &&
      this.propertyData.propertyDetails.get('constructionType').valid &&
      this.propertyData.propertyDetails.get('squareFootage').valid &&
      this.propertyData.propertyDetails.get('yearRoof').valid &&
      this.propertyData.propertyDetails.get('roofMaterial').valid &&
      this.propertyData.locationDetails.get('protectionClass').valid;

    if (!this.isHO4) {
      isValid = isValid && this.propertyData.propertyDetails.get('yearRoof').valid;
    }

    return isValid;
  }

  get isCoveragesFormValid(): boolean {
    let isValid: boolean = false;

    isValid = this.coveragesData.coveragesAndDeductiblesForm.get('coverageA').valid &&
      this.coveragesData.coveragesAndDeductiblesForm.get('allOtherPerilsId').valid &&
      this.coveragesData.coveragesAndDeductiblesForm.get('hurricaneDeductibleid').valid;

    if (!this.isHO4) {
      isValid = isValid && this.coveragesData.coveragesAndDeductiblesForm.get('coverageA').valid;
    }

    if (this.isHO4 || this.isHO6) {
      isValid = isValid && this.coveragesData.coveragesAndDeductiblesForm.get('coverageC').valid;
    }

    return isValid;
  }

  get isHO3(): boolean {
    return this.summaryData.SummaryForm.get('formType')?.value === this.formType.ho3;
  }

  get isHO4(): boolean {
    return this.summaryData.SummaryForm.get('formType')?.value === this.formType.ho4;
  }

  get isHO6(): boolean {
    return this.summaryData.SummaryForm.get('formType')?.value === this.formType.ho6;
  }

  get isDP3(): boolean {
    return this.summaryData.SummaryForm.get('formType')?.value === this.formType.dp3;
  }
}